import React, { type ReactElement } from 'react'
import Dialog, { type DialogProps } from '@mui/material/Dialog'
import { Box, CircularProgress, Typography } from '@mui/material'
import { BUTTON_SIZE, BUTTON_VARIANTS } from 'common/ui/theme-button/ThemeButton'
import ThemeButton from 'common/ui/theme-button'
import { StoreStatus } from 'common/utils/types'

import styles from './ThemeConfirmDialog.module.scss'

interface ThemeConfirmDialogProps extends DialogProps {
  open: boolean
  title?: string
  description?: string
  confirmButtonText?: string
  confirmButtonAction?: () => void
  declineButtonText?: string
  onClose: () => void
  status?: StoreStatus
}

const ThemeConfirmDialog: React.FC<ThemeConfirmDialogProps> = ({
  open,
  title,
  description,
  confirmButtonText,
  declineButtonText,
  onClose,
  confirmButtonAction,
  status,
  ...rest
}): ReactElement => {
  return (
    <Dialog open={open} onClose={onClose} {...rest}>
      <Box className={styles.container}>
        {title && <Typography variant="paragraph">{title}</Typography>}
        {description && <Typography variant="description3">{description}</Typography>}
        <div className={styles.buttonsContainer}>
          {declineButtonText && (
            <ThemeButton size={BUTTON_SIZE.small} variant={BUTTON_VARIANTS.secondary} onClick={onClose}>
              {declineButtonText}
            </ThemeButton>
          )}
          {confirmButtonText && (
            <ThemeButton size={BUTTON_SIZE.small} onClick={confirmButtonAction}>
              {status && status === StoreStatus.Loading && (
                <CircularProgress size={16} sx={{ marginRight: '8px' }} />
              )}
              {confirmButtonText}
            </ThemeButton>
          )}
        </div>
      </Box>
    </Dialog>
  )
}

export default ThemeConfirmDialog
